import actions from './actions'
import mutations from './mutations'

const state = {
  achievementEvents: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}